module.exports = __webpack_public_path__ + "8a405db0d230f726cb0c57d10c47ad3e.svg";